import { SlingTipContainer } from '@sdk/common/slingTip/SlingTip';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';

import { TextContainer, Content, UpdateButton } from './missingBillingAddressTopTip.styles';
import { useMissingBillingAddressTopTip } from './missingBillingAddressTopTip.hooks';

type Props = {
  isErrorTip: boolean;
};

export const MissingBillingAddressTopTip = ({ isErrorTip }: Props) => {
  const { tipColors, onClick } = useMissingBillingAddressTopTip(isErrorTip);

  return (
    <SlingTipContainer backgroundColor={tipColors.background} noShadow closeAnimation={false}>
      <Content>
        <TextContainer>
          <Text14 color={tipColors.text} semiBold>
            {gettext(
              'Your billing information is incomplete. Please update it at your earliest convenience.'
            )}
          </Text14>
        </TextContainer>

        <UpdateButton onClick={onClick} borderColor={tipColors.text}>
          <Text14 color={tipColors.text}>{gettext('Update now')}</Text14>
        </UpdateButton>
      </Content>
    </SlingTipContainer>
  );
};
